import { render, staticRenderFns } from "./ImageTextCombo.vue?vue&type=template&id=53a89a68&scoped=true&"
import script from "./ImageTextCombo.vue?vue&type=script&lang=js&"
export * from "./ImageTextCombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a89a68",
  null
  
)

export default component.exports